module.exports = __webpack_public_path__ + "static/media/presentation_4.8e97fa96.svg";